import type { PermissionType } from './permission'

export enum AdminAppType {
  WEB_APP = 'WEB_APP',
  TPRO_MOBILE = 'TPRO_MOBILE',
  TL_WEB = 'TL_WEB',
  ALL = 'ALL',
}

export enum AdminAppTypeName {
  WEB_APP = 'Web app',
  TPRO_MOBILE = 'TPro mobile',
  TL_WEB = 'TL Web',
  ALL = 'All apps',
}

export const ADMIN_MODE_LABEL = 'Admin Mode'
export const PROMOTER_MODE_LABEL = 'Promoter Mode'
export const PARTNER_MODE_LABEL = 'Partner Mode'
export const STAFF_PREVIEW_LABEL = 'Staff Preview'

export enum AdminPreviewMode {
  NONE = 'NONE',
  STAFF = 'STAFF',
  PROMOTER = 'PROMOTER',
}

export type AdminPreviewState = {
  mode: AdminPreviewMode
  displayName?: string
  enabledPermissionTypes?: PermissionType[]
  staffMemberId?: string
  relationshipId?: string
}
